import { isNativeIOS, nativeApp } from '@lemonade-hq/uniclient-mobile-bridge';
import { useEffect } from 'react';

export const useIOSAutoScrollToInput = (): void => {
  useEffect(() => {
    if (!isNativeIOS()) return;

    let timeoutId: NodeJS.Timeout;

    const cleanup = nativeApp.listenForMessage('keyboardWillShow', ({ duration }) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        document.activeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, duration / 2);
    });

    return () => {
      cleanup();
      clearTimeout(timeoutId);
    };
  }, []);
};
